export const carouselSlides = [
  {
    id: "gp-s1",
    movieId: "gp1002",
    title: "山海归途",
    subtitle: "年度科幻巨制 · 跨越星海的回家之路",
    image: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20cinematic%20key%20art%2C%20lone%20astronaut%20silhouette%20facing%20a%20colossal%20glowing%20mountain%20range%20beneath%20a%20swirling%20cosmic%20sky%2C%20drifting%20stardust%20and%20light%20beams%2C%20warm%20amber%20and%20deep%20crimson%20tones%20for%20strong%20text%20contrast%2C%20grand%20cinematic%20scale%2C%20wide%20composition&width=1600&height=900&seq=gp-hero-01&orientation=landscape",
    tag: "科幻巨制"
  },
  {
    id: "gp-s2",
    movieId: "gp1001",
    title: "长夜将明",
    subtitle: "现实题材犯罪片 · 小人物的坚守与真相",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20key%20art%2C%20rain-soaked%20narrow%20city%20alley%20at%20night%20with%20warm%20neon%20reflections%20on%20wet%20ground%2C%20lone%20silhouetted%20figure%2C%20moody%20deep%20red%20and%20charcoal%20tones%2C%20film%20noir%20atmosphere%2C%20mist%20and%20dramatic%20lighting%2C%20wide%20composition&width=1600&height=900&seq=gp-hero-02&orientation=landscape",
    tag: "口碑热播"
  },
  {
    id: "gp-s3",
    movieId: "gp1003",
    title: "长安十二辰",
    subtitle: "盛唐气象 · 十二个时辰挽救一座城",
    image: "https://readdy.ai/api/search-image?query=Grand%20Tang%20dynasty%20palace%20city%20at%20dusk%20with%20hundreds%20of%20glowing%20red%20lanterns%2C%20ornate%20roof%20tiles%20and%20golden%20decorations%2C%20warm%20amber%20light%20against%20deep%20dark%20sky%2C%20imperial%20majesty%2C%20cinematic%20key%20art%2C%20wide%20composition&width=1600&height=900&seq=gp-hero-03&orientation=landscape",
    tag: "古装大戏"
  },
  {
    id: "gp-s4",
    movieId: "gp1015",
    title: "代号·破晓",
    subtitle: "谍战新片 · 黎明前最惊险的传递",
    image: "https://readdy.ai/api/search-image?query=Tense%20spy%20thriller%20cinematic%20key%20art%2C%20dim%20underground%20bunker%20with%20flickering%20lamps%2C%20covert%20agent%20in%20a%20trench%20coat%2C%20smoke%20and%20long%20shadows%2C%20cold%20steel%20gray%20with%20striking%20red%20accents%20for%20contrast%2C%20wide%20composition&width=1600&height=900&seq=gp-hero-04&orientation=landscape",
    tag: "谍战新片"
  }
];